import { ROLES } from '../enums/ROLES';
import { useAppSelector } from '../store/hooks';

export const useCanViewEmails = () =>
  useAppSelector(({ user }) => user.role === ROLES.ORGANIZATION_ADMIN || user.role === ROLES.SUPER_ADMIN);
